import parse from 'html-react-parser';
import { useEffect, useState } from 'react';

const HmltToRender = ({ __html }) => {
  // Use state to detect if we are on client side
  const [isClient, setIsClient] = useState(false);
  
  // Lazy load DOMPurify only on client
  const [sanitizer, setSanitizer] = useState(null);

  useEffect(() => {
    setIsClient(true);
    import('dompurify').then((module) => {
        setSanitizer(() => module.default);
    });
  }, []);

  if (!__html) return null;

  // During SSR or first hydration, render a simple div or null to avoid mismatch
  // data.__html might contain complex HTML that causes hydration issues
  if (!isClient || !sanitizer) {
      return <div dangerouslySetInnerHTML={{__html: __html}} />;
  }
  
  const sanitizedData = sanitizer.sanitize(__html);
  return <div>{parse(sanitizedData)}</div>;
};

export default HmltToRender;
